import {createBrowserRouter, createRoutesFromElements, Route} from 'react-router-dom'
import {login} from "./PublicPages";
import {privatePages} from "./PrivatePages";
import PrivateRoute from "./PrivateRoute";


const privatePagesPaths = privatePages

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/">
            {privatePagesPaths.map((page, index) => {
                return (
                    <Route
                        key={index}
                        path={page.path}
                        element={
                        <PrivateRoute>
                            <page.view />
                        </PrivateRoute>
                        }
                    />
                )
            })}
            <Route path={login.path} element={<login.view />} />

            <Route path={'/*'} element={<login.view />} />
        </Route>
    )
)
